import { render } from "./InvoicesTable.vue?vue&type=template&id=732755fe&ts=true"
import script from "./InvoicesTable.vue?vue&type=script&lang=ts"
export * from "./InvoicesTable.vue?vue&type=script&lang=ts"

import "./InvoicesTable.vue?vue&type=style&index=0&id=732755fe&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__